import React from 'react'
import StateIcon from 'components/global/StateIcon'
import TemporaryIcon from 'components/global/TemporaryIcon'
import { AlertContainer, AlertIcons, AlertText } from './Styles'
import { Typography, Stack } from '@mui/material'

interface EmptyScreenProps {
  children: React.ReactNode
  icon?: string
  iconSize?: string
  iconWeight?: string
  fontSize?: string
  spacing?: number
  variant?: 'default' | 'compact' | 'map' | 'panel'
  height?: string
}

const EmptyScreen: React.FC<EmptyScreenProps> = ({ 
  children, 
  icon = 'wifi',
  iconSize = '100px',
  iconWeight = 'regular',
  fontSize = '12px',
  spacing = 1,
  variant = 'default',
  height
}) => {
  if (variant === 'compact') {
    return (
      <Stack 
        alignItems="center" 
        justifyContent="center" 
        spacing={spacing}
        sx={{ 
          py: 2,
          px: 1,
          textAlign: 'center',
          height: height || 'auto'
        }}
      >
        <TemporaryIcon 
          iconlabel={icon} 
          iconsize={variant === 'compact' ? '20px' : iconSize}
          iconcolor="#d5d5d5"
          iconweight={iconWeight}
        />
        <Typography 
          sx={{ 
            fontSize: fontSize,
            color: '#656565',
            fontFamily: 'Poppins',
            fontWeight: 400,
            lineHeight: 1.4,
            maxWidth: '200px'
          }}
        >
          {children}
        </Typography>
      </Stack>
    )
  }

  return (
    <AlertContainer variant={variant} sx={{ height: height || '100%' }}>
      <AlertText>
        {children}
      </AlertText>
      <AlertIcons>
        <StateIcon
          iconlabel={icon}
          iconcolor={'#f3f5f6ff'}
          iconsize={iconSize}
          iconweight={iconWeight}
        />
      </AlertIcons>
    </AlertContainer>
  )
}

export default EmptyScreen